import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { MealsPupop } from "./MealsPupop"
import { useGetMeals } from "../../../hooks/Meals/useGetMeals"
import { mealsMemory } from "../../../Objects/Memory/Memory"
import { MealEntity } from "../../../Objects/MealsAndDrinks/MealEntity"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetCategory } from "../../../hooks/Category/useGetCategory"
import { useTranslation } from "react-i18next"
import { GenericFoodEntity } from "../../../Objects/MealsAndDrinks/GenericFoodEntity"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"
import { ProductQuickEditPopup } from "../../../components/QuickEditGrid/ProductQuickEditPopup"
import { faTableCells } from "@fortawesome/free-solid-svg-icons"
import { useQuickActionPopup } from "../../../hooks/useQuickActionPopup"

export const MealsPage: React.FC = () => {
  const { t } = useTranslation("meal")

  const [enableMeals, setEnableMeals] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const [enableQuickEdit, setEnableQuickEdit] = useState(false)

  const { handleGetCategory } = useGetCategory()

  const { handleGetMeals } = useGetMeals()

  const [drink, setDrink] = useState<MealEntity | undefined>(undefined)

  const hasEditableMeals = mealsMemory.getAll().length > 0

  useEffect(() => {
    const loadData = async () => {
      await handleGetCategory(async () => await handleGetMeals(() => {}))
    }

    loadData()
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const promotion = mealsMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setDrink(promotion)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setDrink(undefined)

    setEnableMeals(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  useQuickActionPopup("meals-quick-edit", () => setEnableQuickEdit(true), hasEditableMeals)

  const handleCopyMeal = () => {
    if (!drink) {
      return
    }

    setDrink(
      new MealEntity({
        ...drink,
        id: -1,
        genericFoodEntity: new GenericFoodEntity({
          ...drink.genericFoodEntity,
          id: -1,
          iconUrl: "",
        }),
      }),
    )
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          data={mealsMemory.getListCards(true)}
          messageCount={t("list:label_meals_page_message_count")}
          messageEmpty={t("list:label_meals_page_message_empty")}
          nameFindSearch={t("list:label_meals_page_place_holder")}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleExtraFloatButton={hasEditableMeals ? () => setEnableQuickEdit(true) : undefined}
          extraFloatButtonDescriptionKey="interactionDescriptions:components.list.list.button.handleQuickEditMeals"
          extraFloatButtonIcon={faTableCells}
          extraFloatButtonColor="#f97316"
          handleRefreshButton={() => handleGetMeals(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
        />
      </div>

      {enableMeals && (
        <MealsPupop
          meals={drink}
          title={drink && drink.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyMeal}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="refeicoes"
          title={t("dataImport:title", { target: t("dataImport:target_meals") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetMeals(() => {})}
        />
      )}

      {enableQuickEdit && hasEditableMeals && (
        <ProductQuickEditPopup
          target="meal"
          products={mealsMemory.getAll()}
          onClose={() => setEnableQuickEdit(false)}
          onReload={async () => {
            await handleGetMeals(() => {})
          }}
        />
      )}
    </>
  )
}
